export default {
    wizardType: "MONGOCOSMOS",

    getJDBCURL: (m) => m.get("host") + ":" + m.get("port"),

    getConnectionParams: (type, model) => ({
        UserName: model.get("username"),
        Password: model.get("password"),
        ConnectionURL: model.getJDBCURL(),
    }),
};

